/** Типы отображения форм */
export enum EShowTypes {
    field,
    baseForm,
    registryForm,
    storyForm,
    alternativeForm,
}

/** Типы показателей */
export enum EFieldsTypes {
    digit = 'digit',
    bool = 'bool',
    date = 'date',
    string = 'string',
    text = 'text',
    list = 'list',
    address = 'address',
    file = 'file',
    gallery = 'gallery',
    link = 'link',
    relation = 'relation',
    reestr = 'reestr',
    numerator = 'numerator',
    access = 'access',
    relationObject = 'relation_object',
    interaction = 'interaction',
    technical_process = 'technical_process',
    all_data = 'all_data',
    relation_object = 'relation_object',
    file_versions = 'file_versions',
    /** @deprecated */
    registry = 'registry',
}

/** Типы форматов дат */
export enum EDateFormat {
    date = '1',
    monthYear = '2',
    year = '3',
    month = '4',
    dateTime = '5',
    dayMonth = '6',
}

/** Форматы входов в систему */
export enum ELoginFormats {
    // По паролю и логину
    Standart = 'without_esia',
    // Через ЕСИА
    ESIA = 'by_esia',
    // Через все возможные
    Full = 'together_esia',
}

/** Элиасы доступов */
export enum EAccessAlias {
    /** Доступ для внешнего модуля внутри которого каждый дочерний модуль имеет свой доступ */
    modulePermission = 'insertPermission',
    /** Элиас доступа в настройкам */
    settingsPermission = 'settings',
    /** Элиас уровни доступа */
    accessLevelPermission = 'access_level',
    /** Элиас настройка языков */
    languagesPermission = 'languages',
    /** Элиас настройка карты */
    settingsMapPermission = 'map',
    /** Элиас дерево рубрикаторов */
    rubricatorsPermission = 'rubricator',
    /** Элиас настройка помощи */
    HelpSettingsPermission = 'help',
    /** Элиас настройка производственного календаря */
    calendarPermission = 'languages',
    /** Элиас настройка помощи */
    NumeratorPermission = 'numerators',

    /** Элиас настройка помощи */
    ApiSettingsPermission = 'api',

    /** Элиас график предоставления сведений */
    FactorSchedulerPermission = 'factor_show',

    /** Элиас список реестров */
    RegistryListPermission = 'factor_input',

    /** Элиас "Раздел настройки документов по шаблону" */
    ReportsDocumentsPermission = 'admin_report',

    /** Элиас конструктора реестров */
    FactorConstructorPermission = 'factor',
    /** Элиас данных реестра  */
    FactorRowPermission = 'factor_input',
}

/** Размеры элементов скелетона */
export enum ESkeletonItemHeight {
    HeightInputField = '40px',
    HeightTextarea = '69px',
}

/** Расположения тултипа */
export enum ETooltipPosition {
    below = 'below',
    above = 'above',
    left = 'left',
    right = 'right',
}

export enum EDateType {
    single,
    period,
}
